module.exports = __webpack_public_path__ + "static/media/12.8c935783.jpg";